import React, { PureComponent } from 'react'

import { oneOfType, array, object, node, string } from 'prop-types'
import { Helmet } from 'react-helmet'

import ColumnMain from 'components/ColumnMain'
import Content from 'components/Content'
import Breadcrumbs from 'containers/Breadcrumbs'
import Title from 'UI/Title'

import styles from './PageFullWidth.scss'

export default class PageFullWidth extends PureComponent {
  static propTypes = {
    children: oneOfType([array, object]).isRequired,
    title: node,
    breadcrumbs: array,
    metaTitle: string
  }

  static defaultProps = {
    breadcrumbs: [],
    title: '',
    metaTitle: ''
  }

  render() {
    const { title, metaTitle, children, breadcrumbs } = this.props

    return (
      <div className={styles.pageFullWidth}>
        {(metaTitle || title) && <Helmet title={metaTitle || title || ''} />}
        <Content>
          <ColumnMain isFullWidth>
            {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
            {title && <Title>{title || ''}</Title>}

            {children}
          </ColumnMain>
        </Content>
      </div>
    )
  }
}
